import type { DialogConfig } from '@/components/ui/typedefs'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useUiDialogStore = defineStore('uiDialog', () => {
  const openedDialogConfig = ref<DialogConfig | null>(null)

  const openDialog = (config?: DialogConfig) => {
    openedDialogConfig.value = {
      ...config,
      // Set fallback value when  primary button is not set *or empty string*.
      primaryButtonText: config?.primaryButtonText || 'OK',
      imagePosition: config?.imagePosition || 'top'
    }
  }

  const closeDialog = () => (openedDialogConfig.value = null)

  const onPrimaryButtonClick = () => {
    openedDialogConfig.value?.onPrimaryButtonClick?.()
    closeDialog()
  }

  const onSecondaryButtonClick = () => {
    openedDialogConfig.value?.onSecondaryButtonClick?.()
    closeDialog()
  }

  // A shortcut for using uiDialog in a similar way as window.alert(...).
  const showAlert = (message: string) => {
    openDialog({
      text: message,
      primaryButtonText: 'OK'
    })
  }

  const $reset = () => {
    openedDialogConfig.value = null
  }

  return {
    // Generic API.
    openDialog,
    closeDialog,

    // Public state.
    isOpen: computed(() => openedDialogConfig.value !== null),
    openedDialogConfig: computed(() => openedDialogConfig.value),

    onPrimaryButtonClick,
    onSecondaryButtonClick,

    showAlert,
    $reset
  }
})
